module.exports = __webpack_public_path__ + "img/keuntungan.d12dee60.png";